import { styled } from "../../../styled-components";

export const RadioButtonsStyle = styled.div``;

export const RadioButtonStyle = styled.label`
    display: flex;
    width: 100%;

    cursor: pointer;

    --top: 14px;

    input {
        --size: 16px;
        width: var(--size);
        height: var(--size);
        border: 1px solid;
        border-color: ${p => p.theme.fgColorLight};
        border-radius: calc(var(--size) / 2);
        margin-top: var(--top);
    }

    .label {
        flex-grow: 1;
        border-bottom: 1px solid ${p => p.theme.offBaseColor};
        padding: var(--top) 0 10px 0;
        margin-left: 10px;
        color: ${p => p.theme.fgColorDark};
    }

    &.current input {
        border-color: ${p => p.theme.primaryAccentColor};
        background-color: ${p => p.theme.primaryAccentColor};
        background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='8' cy='8' r='3'/%3e%3c/svg%3e");
    }

    ${p => p.theme.fontStyles.Body4}
`;
